import React from 'react'
import { Container, Typography, Button, Box, Paper } from '@mui/material';
import { makeStyles } from '@mui/styles';



const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
      textAlign: 'center',
  },
}));


function AboutPage() {

  const classes = useStyles();

  return (
    <Container className={classes.root}>
      <Paper className={classes.paper}>
        <Typography variant="h2" component="h1" gutterBottom>
          Welcome to Our Website
        </Typography>
        <Typography variant="h6" component="p" paragraph>
          Discover the best services tailored for your needs. We offer a variety of solutions to help you achieve your goals.
        </Typography>
        <Button variant="contained" color="primary" className={classes.button}>
          Get Started
        </Button>
      </Paper>
    </Container>
  )
}

export default AboutPage